<svg viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.3623 0.0473633L12.423 6.10796L6.3623 12.1687L5.30161 11.108L9.55161 6.85796H0.612305V5.35796H9.55161L5.30161 1.10796L6.3623 0.0473633Z"
    fill="currentColor"
  />
</svg>
